import { AnyIfEmpty } from 'react-redux';
import { GET_METRICS_REQUEST, GET_METRICS_FAILURE, GET_METRICS_SUCCESS } from '../constants/metrics.constant'

const initialState = {
	loading: false,
	data: [],
	errorMsg: '',
};

interface action {
	payload: AnyIfEmpty<object>;
	type: string;
}

export const metricsReducer = (state = initialState, action: action) => {
	switch (action.type) {
		case GET_METRICS_REQUEST:
			return {
				...state,
				loading: true,
				loginError: '',
			};

		case GET_METRICS_SUCCESS:
			return {
				...state,
				loading: false,
				data: action.payload,
				loginError: '',
			};
		case GET_METRICS_FAILURE:
			return {
				...state,
				loading: false,
				data: [],
				loginError: action.payload,
			};
		default:
			return state;
	}
};